import { Component } from "@omnia/shared/shell/component"
import { INVZMessages } from "../../../nvz/types"
import { defineComponent, isNumber } from "../../../omnia"
import { INutritionPlan, ProductAppInput } from "../../../types"
import { PlanEditCtrl } from "../edit"
import { PlanEditContext } from "../editContext"
import { IEditPlanCroppingArguments } from "../types"
import { CroppingEditVm } from "./croppingEditVm"
import { CroppingGroup } from "./croppingGroup"
import { IAppSummary } from "./types"


export class EditPlanCroppingCtrl extends Component {

    static create(): ng.IDirective {

        var def = defineComponent(EditPlanCroppingCtrl, "app/nutrition/plan/edit/cropping/cropping.html");

        def.require = "^omniaNutriPlanEdit";

        def.link = EditPlanCroppingCtrl.link;


        return def;

    };


    static link(scope, elt, attrs, parent: PlanEditCtrl) {
        var ctrl: EditPlanCroppingCtrl = scope["vm"];
        ctrl.parentCtrl = parent;
    }

    private parentCtrl: PlanEditCtrl;

    private ctxt: PlanEditContext;

    private groups: CroppingGroup[];
    private cropping: CroppingEditVm[];

    public currentCropping: CroppingEditVm;

    private nvzMessages: INVZMessages;


    static $inject = ["$scope", "$q", "$uibModal"];

    constructor($scope: ng.IScope, private $q: ng.IQService, private $uibModal) {

        super($scope);

        this._icon = "fas fa-pen";
        this._title = "Nutrition plan / edit cropping";
    }

    get currentPlan(): INutritionPlan {
        return this.ctxt.target;
    }

    protected setup() {

        var args: IEditPlanCroppingArguments = this.execArguments;

        this.ctxt = args.context;

        this.cropping = this.ctxt.getCropping()

        this.groups = CroppingGroup.createGroups(this.cropping);

        this.$scope.$watch("vm.currentPlan", () => this.updatePlanInfo());

    }

    updatePlanInfo() {

        let cropping = this.cropping.filter(c => c.selected)

        cropping.forEach(c => c.updateCalculatedValues())

        this.nvzMessages = this.ctxt.getNVZMessages(cropping)

        cropping.forEach(c => {
            c.nvzMessages = this.nvzMessages.messages.filter(m => m.croppingId == c.croppingId)
        })

    }

    showCroppingsPopup(): void {

        const scope = this.$scope.$new(true);

        scope["croppings"] = this.cropping?.filter(c => c.authorized)
        scope["context"] = this;

        this.$uibModal.open({
            template: "<omnia-nutri-plan-edit-cropping-popup />",
            scope: scope
        });
    }

    public showDetails(croppingVM: CroppingEditVm): boolean {
        if (croppingVM.hasNVZWarnings()) {
            return true;
        }
        return croppingVM.expanded;
    }

    public toggleDetails(croppingVM: CroppingEditVm) {
        if (!croppingVM.hasNVZWarnings()) {
            croppingVM.expanded = !croppingVM.expanded;
        }
    }

    selectCropping(cropping: CroppingEditVm) {
        cropping.selected = true;
        cropping.updateCalculatedValues();
    }

    removeCropping(cropping: CroppingEditVm, cancel: boolean) {

        if (!cropping.currentPlanBinding) {
            cropping.selected = false;
            cropping.expanded = false;
        }
        else {
            cropping.remove = !cancel;
        }

    }

    hasSelectedItems(): boolean {
        return this.cropping && this.cropping.some(c => c.selected);
    }

    get showLime() {
        return this.ctxt && this.ctxt.showLime
    }

    get limeUnits() {
        return "kg/ha"
    }

    canCommit(): boolean {
        return true
    }

    commit() {

        this.ctxt.cropping = this.cropping;
        this.closeComponent();

    }

    close() {
        this.ctxt.showCroppingSelector = false;
    }

    canRemoveCropping(cropping: CroppingEditVm): boolean {
        const { ctxt } = this
        return ctxt && cropping && (!cropping.remove) && (!ctxt.isEditingProduct) && (!ctxt.readOnly)
    }

    canAddCropping(): boolean {
        const { ctxt } = this
        return ctxt && (!ctxt.isEditingProduct) && (!ctxt.readOnly)
    }

    isEditingProduct() {
        const { ctxt } = this
        return ctxt && ctxt.isEditingProduct
    }

    hasOverrides(c: CroppingEditVm, p: IAppSummary): boolean {

        if (c && p) {
            return p.vm.hasOverrides(c.croppingId)
        }

        if (c && this.ctxt) {
            return this.ctxt.hasOverridesForCropping(c.croppingId)
        }

    }

    hasCustomProductRate(c: CroppingEditVm, p: IAppSummary) {
        return hasCustomRate(c, p, ProductAppInput.ProductRate)
    }

    hasCustomNutrientRate(c: CroppingEditVm, p: IAppSummary) {
        return hasCustomRate(c, p, ProductAppInput.NutrientRate)
    }

    clearOverrides(crop: CroppingEditVm, app: IAppSummary) {

        app.vm.overrideCroppingRate(crop, undefined)
        crop.updateCalculatedValues()

    }

    updateRate(crop: CroppingEditVm, app: IAppSummary, rate: number, defaultRate: number, type: ProductAppInput) {

        const value = (rate == defaultRate) && isNumber(defaultRate)
            ? undefined
            : { rate, type }

        app.vm.overrideCroppingRate(crop, value)
        crop.updateCalculatedValues()
        this.ctxt.updateTargetModel(app.vm)

    }

    updateProductRate(crop: CroppingEditVm, app: IAppSummary) {
        this.updateRate(crop, app, app.productRate, app.vm.productRate, ProductAppInput.ProductRate)
    }

    updateNutrientRate(crop: CroppingEditVm, app: IAppSummary) {
        this.updateRate(crop, app, app.nutrientRate, app.vm.nutrientRate, ProductAppInput.NutrientRate)
    }

    canUpdateRates(crop: CroppingEditVm, app: IAppSummary) {
        const { ctxt } = this
        return ctxt && (!ctxt.isEditingProduct) && (!ctxt.readOnly)
    }

}

function hasCustomRate(c: CroppingEditVm, p: IAppSummary, type: ProductAppInput) {

    if (c && p) {

        const ovr = p.vm.getCroppingOverride(c.croppingId)

        if (ovr) {
            return (type == ovr.LastInputUsed)
        }
    }

}
